import RequestPageTwo from "./RequestPageTwo";

const InternalRetreatReg = () => {
    return (
        <RequestPageTwo title="Internal Retreat Registrations"
            fetchUrl="/get-internal-retreat-registrations"
            editEndpoint="update-internal-retreat-registrations"
            deleteEndpoint="internal-retreat-registrations"
            statusEndpoint="update-internal-retreat-registrations" />
    );
}

export default InternalRetreatReg;
